import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";

import Grid from "../../components/Grid";
import { Select } from "../../components/Form";

export default function SaleObjFilterMiddle3({
  global,
  inquiry,
  headoffice,
  latestArray,
  pageArray,
  pageSize,
  onChangePage = () => {},
  latest,
  onChangeLatest = () => {},
  landRightsArray,
  landRightsObject,
  onChangeLandRights = () => {},
  buildRightsArray,
  buildRightsObject,
  onChangeBuildRights = () => {},
  pointHandArray,
  pointHandObject,
  onChangePointHand = () => {},
  sourceOfTheCaseArray,
  sourceOfTheCaseObject,
  onChangeSourceOfTheCase = () => {},
  roadConditionArray,
  roadConditionObject,
  onChangeRoadCondition = () => {},
}) {
  const useStyles = makeStyles({
    DocumentContainerRow: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
    },
    DocumentContainerColumn: {
      flexDirection: "column",
    },
    DocumentContainerCenter: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
    },
  });
  const classes = useStyles();
  return (
    <Box padding={1} width="100%" style={{ backgroundColor: "white" }}>
      <Grid container spacing={1}>
        <Grid
          container
          item
          spacing={1}
          classes={{ root: classes.DocumentContainerColumn }}
        ></Grid>
        <Grid container item spacing={1}>
          {!inquiry && (
            <>
              <Grid item xs={4} sm={2}>
                <Typography color="primary" style={{ fontSize: 15 }}>
                  是否點交
                </Typography>
                <Select
                  items={pointHandArray}
                  value={pointHandObject.value ? pointHandObject : null}
                  onChange={(e, value) => {
                    if (value) {
                      onChangePointHand(value);
                    } else {
                      onChangePointHand();
                    }
                  }}
                  fullWidth
                />
              </Grid>
              {global && (
                <Grid item xs={4} sm={2}>
                  <Typography color="primary" style={{ fontSize: 15 }}>
                    案件來源
                  </Typography>
                  <Select
                    items={sourceOfTheCaseArray}
                    value={
                      sourceOfTheCaseObject.value ? sourceOfTheCaseObject : null
                    }
                    onChange={(e, value) => {
                      if (value) {
                        onChangeSourceOfTheCase(value);
                      } else {
                        onChangeSourceOfTheCase();
                      }
                    }}
                    fullWidth
                  />
                </Grid>
              )}
              {headoffice && (
                <Grid item xs={4} sm={2}>
                  <Typography color="primary" style={{ fontSize: 15 }}>
                    臨路狀況
                  </Typography>
                  <Select
                    items={roadConditionArray}
                    value={
                      roadConditionObject.value ? roadConditionObject : null
                    }
                    onChange={(e, value) => {
                      if (value) {
                        onChangeRoadCondition(value);
                      } else {
                        onChangeRoadCondition();
                      }
                    }}
                    fullWidth
                  />
                </Grid>
              )}

              <Grid item xs={4} sm={3}>
                <Typography color="primary" style={{ fontSize: 15 }}>
                  土地權利
                </Typography>
                <Select
                  items={landRightsArray}
                  value={landRightsObject.value ? landRightsObject : null}
                  onChange={(e, value) => {
                    if (value) {
                      onChangeLandRights(value);
                    } else {
                      onChangeLandRights();
                    }
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={4} sm={3}>
                <Typography color="primary" style={{ fontSize: 15 }}>
                  建物權利
                </Typography>
                <Select
                  items={buildRightsArray}
                  value={buildRightsObject.value ? buildRightsObject : null}
                  onChange={(e, value) => {
                    if (value) {
                      onChangeBuildRights(value);
                    } else {
                      onChangeBuildRights();
                    }
                  }}
                  fullWidth
                />
              </Grid>
            </>
          )}
          <Grid item xs={4} sm={2}>
            <Typography style={{ color: "#FF9301", fontSize: 15 }}>
              排序
            </Typography>
            <Select
              items={latestArray}
              value={latest.value ? latest : null}
              onChange={(e, value) => {
                if (value) {
                  onChangeLatest(value);
                } else {
                  onChangeLatest();
                }
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={4} sm={2}>
            <Typography style={{ color: "#FF9301", fontSize: 15 }}>
              每頁顯示
            </Typography>
            <Select
              items={pageArray}
              value={pageSize ? pageSize : null}
              onChange={(e, value) => {
                if (value) {
                  onChangePage(value);
                } else {
                  onChangePage();
                }
              }}
              fullWidth
            />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
